<div [attr.redPosition]="position" red-icon [attr.background]="background" [attr.redShape]="shape" [attr.redSize]="size"
  [attr.redIconAlign]="align">
  <ng-content></ng-content>
</div>